import { TrendingUp } from 'lucide-react';
import styles from './TrendIndicator.module.css';

function TrendIndicator({ value, suffix = 'vs last period', showIcon = true }) {
    if (value === null || value === undefined) return null;

    const isPositive = value > 0;
    const isNegative = value < 0;
    const variant = isPositive ? 'positive' : isNegative ? 'negative' : 'neutral';

    const displayValue = `${isPositive ? '+' : ''}${value.toFixed(1)}%`;

    return (
        <span className={`${styles.trendIndicator} ${styles[variant]}`}>
            {showIcon && (
                <span className={`${styles.icon} ${isNegative ? styles.negative : ''}`}>
                    <TrendingUp size={12} />
                </span>
            )}
            <span>{displayValue}</span>
            {suffix && <span>{suffix}</span>}
        </span>
    );
}

export default TrendIndicator;
